import createAttachmentFiles from '../../utils/createAttachmentFiles';
import { AttachmentDetails } from 'owa-addins-core';
import { isFeatureEnabled } from 'owa-feature-flags';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import {
    ComposeOperation,
    ComposeTarget,
    ComposeViewStateInitProps,
    lazyOpenCompose,
} from 'owa-mail-compose-store';

export function displayNewMessageForm(
    toRecipients?: EmailAddressWrapper[],
    ccRecipients?: EmailAddressWrapper[],
    bccRecipients?: EmailAddressWrapper[],
    subject?: string,
    htmlBody?: string,
    attachments?: AttachmentDetails[]
) {
    if (isFeatureEnabled('rp-popouts')) {
        const composeInitProps = <ComposeViewStateInitProps>{
            operation: ComposeOperation.New,
            bodyType: 'HTML',
            subject: subject,
            newContent: htmlBody,
            to: toRecipients,
            cc: ccRecipients,
            bcc: bccRecipients,
            preferAsyncSend: true,
        };
        const attachmentFiles = createAttachmentFiles(attachments);
        lazyOpenCompose.importAndExecute(
            composeInitProps,
            ComposeTarget.Popout,
            null /* groupId */,
            attachmentFiles
        );
    }
}
